module.exports = __webpack_public_path__ + "static/media/sites.7f583098.png";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/sites.png
// module id = 1101
// module chunks = 0